export const ExternalOrderFromJson = (json: IExternalOrderResponse): IExternalOrderModel => ({
	id: json.id,
	source: json.source,
	externalIdentifier: json.external_identifier,
	email: json.email,
	deliveryDate: json.delivery_date,
	status: json.status,
	statusReason: json.status_reason,
	itemsCount: json.items_count,
	wantsReceipt: json.wants_receipt,
	receiptUrl: json.receipt_url,
})
